import axios from "axios";
import {createUrlParams} from "../utils/urlParams";


export const getCountries = async () => {
    const url = '/api/v1/territory/countries';

    const res = await axios.get(url);
    return res.data;
}

export const getRegions = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/territory/regions?${urlParams.toString()}`;

    const res = await axios.get(url);
    return res.data;
}

export const getRegion = async (regionId) => {
    const url = `/api/v1/territory/regions/${regionId}`;

    const res = await axios.get(url);
    return res.data;
}


export const getProvinces = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/territory/provinces?${urlParams.toString()}`;

    const res = await axios.get(url);
    return res.data;
}


export const getProvince = async (provinceId) => {
    const url = `/api/v1/territory/provinces/${provinceId}`;

    const res = await axios.get(url);
    return res.data;
}


export const getMunicipalities = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/territory/municipalities?${urlParams.toString()}`;

    const res = await axios.get(url);
    return res.data;
}


export const getMunicipality = async (municipalityId) => {
    const url = `/api/v1/territory/municipalities/${municipalityId}`;

    const res = await axios.get(url);
    return res.data;
}